module.exports = __webpack_public_path__ + "static/media/jca-architects.cdbb2c4f.png";